import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/ContainerStatus/ContainerStatusTripType.css';
import containerhead from '../../../Assets/ContainerStatus/Assets_Desktop/container.svg';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { CONTAINER_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { successContainerTrip } from '../../../Redux/_actions/containerTripData.action';

class ContainerStatusTripType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            containerDetails: [],
            containerAllDataLoad: true,
            containerNumber: '',
        }
    }
    componentDidMount() {
        const { containerNumber } = this.props.match.params;
        this.setState({ containerNumber: containerNumber });
        ApiCall(
            'GET',
            trackingBaseURL + CONTAINER_DETAILS_ENDPOINT + `?containerNumber=${containerNumber}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    this.setState({ containerAllDataLoad: false });
                } else {
                    console.log('I am 200!');
                    apiData?.map((name, index) => {
                        if (name.container.tripType == "Transship") {
                            name.container.tripType = "Transshipment"
                        }
                        return name;
                    });
                    this.setState({ containerDetails: apiData });
                    this.setState({ containerAllDataLoad: true });
                }
            }
        });
    }
    handleContainer = event => {
        this.state.containerDetails?.find((terminaldata1) => {
            if (terminaldata1.container.tripType === this.state.containerDetails[event].container.tripType && terminaldata1.position === this.state.containerDetails[event].position) {
                this.props.dispatch(successContainerTrip(terminaldata1))
                this.props.history.push({
                    pathname: `/containerDetails/${this.state.containerNumber}/${terminaldata1.container.tripType}/${terminaldata1.position}`
                })
            }
        })
    }
    render() {
        return (
            <div class="csoutercolor" >
                <MetaDecorator title={TitleDescription.tripTypePageTitle} description={TitleDescription.tripTypePageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="containertriptyprfull">
                    <div id="csnobox1">
                        <nav class="ccnononavbar">
                            <div className="ccnonavbarname">
                                <small id="nonavc"> Container Status</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationmaincard">
                            <div class="containerconcsdivlow1">
                                <div class="containercsdivlow2">
                                    <img src={containerhead} class="mr-3" id="" alt="" loading="lazy" />Container No.
                                    <small class="pl-3" id="csupdivsm">{this.state.containerNumber}</small></div>
                            </div>
                            {this.state.containerAllDataLoad == true ?
                                this.state.containerDetails?.map((terminaldata1, index) => {
                                    return (
                                        <div class="ctconsdiv1" onClick={() => this.handleContainer(index)}>
                                            <div class="ctconsdiv2" >
                                                <div class="ctconsdiv3">
                                                    <div class="consdiv4">
                                                        <div class="consdiv5">
                                                            <small class="consdiv6">Terminal</small>
                                                        </div>
                                                        <div class="consdiv7">
                                                            <small class="consdiv8">{terminaldata1?.container?.terminalName?.split(':')[0]}</small>
                                                        </div>
                                                    </div>
                                                    <div class="consdiv9">
                                                        <div class="consdiv5">
                                                            <small class="consdiv6">Trip Type</small>
                                                        </div>
                                                        <div class="consdiv11">
                                                            <small class="consdiv8">{terminaldata1?.container?.tripType}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="ctconsdiv12">
                                                    <img src={rightarrow} id="rightarrowimg" height="18" width="18" class="" alt="" loading="lazy" />
                                                </div>
                                            </div>
                                        </div>);
                                })
                                :
                                <div class="newnotificationTripType">
                                    <small id="nonotificationTripType">No result found</small>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default ContainerStatusTripType;
